<template>
  <div class="cartcontrol">
    <transition name="fade">
      <div class="decrease" @click.stop="decreaseCount($event)" v-show="food.count>0 || food.count">
        <i class="icon-remove_circle_outline"></i>
      </div>
    </transition>
    <div class="count" v-show="food.count>0 || food.count">{{food.count}}</div>
    <div class="add" @click.stop="addCount($event)">
    <i class="icon-add_circle"></i>
  </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import Vue from 'vue';
  export default{
    props: {
      food: {
        type: Object,
        default: {}
      }
    },
    methods: {
      addCount(event) {
        if (!event._constructed) {
          return;
        }
        if (!this.food.count) {
          Vue.set(this.food, 'count', 1);
        } else {
          this.food.count++;
        }
      },
      decreaseCount(event) {
        if (!event._constructed) {
          return;
        }
        if (!this.food.count) {
          Vue.set(this.food, 'count', 0);
        } else {
          this.food.count--;
        }
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .cartcontrol
    display:flex
    .decrease, .add
      padding:6px
      text-align:center
      font-size:24px
      line-height:24px
      color:rgb(0, 160, 220)
      vertical-align:top
    .count
      width:24px
      text-align:center
      font-size:10px
      line-height:36px
      color:rgb(147, 153, 159)
    .decrease
      .icon-remove_circle_outline
        display:block  /*块级元素才有旋转的概念*/
      &.fade-enter-active,&.fade-leave-active
        transition:all 0.4s linear
        .icon-remove_circle_outline
          transition:all 0.4s linear
      &.fade-enter,&.fade-leave-active
        transform:translate(100%,0)
        opacity:0
        .icon-remove_circle_outline
          transform:rotate(180deg)
</style>



// WEBPACK FOOTER //
// cartcontrol.vue?316c39f2